import { computed, inject, Injectable, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";

import { LogService } from "src/app/infrastructure/services/log.service";
import { TabDataService } from "../central-page/services/tab-data.service";
import { FilterMode, ISortField } from "src/app/infrastructure/pipes/filter.pipe";

@Injectable()
export class FilterService {
    protected readonly _tabDataService = inject(TabDataService, {optional: true});

    filterString$$ = this._tabDataService?.filterString$$ ?? signal(null);
    get FilterString() {return this.filterString$$()}
    set FilterString(value: string | null) {
        if (this._tabDataService) {
            this._tabDataService.FilterString = value;
        }
    }

    // Filtervelden: volledige set + de aangevinkte subset (komen uit/gaan naar TabStorage → localStorage).
    searchFields$$ = this._tabDataService?.searchFields$$ ?? signal<string[]>([]);
    searchFieldsActive$$ = this._tabDataService?.searchFieldsActive$$ ?? signal<string[]>([]);
    searchField_toggle(field: string) {
        this._tabDataService?.searchField_toggle(field);
    }

    // Sorteerketen voor de instellingen-UI: het EXPLICIETE signaal (sortFieldsStored$$), niet het
    // effectieve sortFields$$ dat de lijst-rendering gebruikt — dat laatste valt terug op de
    // tab-default en zou de instellingenlijst na een reset ongewenst laten herschikken naar dat
    // default-veld (zie TabDataService.sortFieldsStored$$).
    sortFields$$ = this._tabDataService?.sortFieldsStored$$ ?? signal<ISortField[]>([]);
    sortField_toggle(field: string) {
        this._tabDataService?.sortField_toggle(field);
    }

    // Weergavevolgorde van alle velden in het instellingenpaneel — zie TabDataService.fieldOrder$$
    // voor waarom dit een los, bewust-stabiel signaal is i.p.v. elke render opnieuw afgeleid van de
    // sorteerketen.
    fieldOrder$$ = this._tabDataService?.fieldOrder$$ ?? this.searchFields$$;

    // UI-only: of het instellingen-paneel boven het inputveld uitgeklapt is (niet persistent).
    private __settingsOpen$$ = signal(false);
    settingsOpen$$ = this.__settingsOpen$$.asReadonly();
    settingsOpen_toggle() {this.__settingsOpen$$.update(open => !open);}
    settingsOpen_close() {this.__settingsOpen$$.set(false);}

    private __filterMode$$ = signal<FilterMode>('and');
    filterMode$$ = this.__filterMode$$.asReadonly();
    get FilterMode() {return this.__filterMode$$()}
    set FilterMode(value: FilterMode) {this.__filterMode$$.set(value)}
    filterMode_toggle() {
        this.FilterMode = this.FilterMode === 'and' ? 'or' : 'and';
    }

    private __filterShow$$ = signal<boolean | null>(null)
    filterShow$ = toObservable(this.__filterShow$$)
    filterShow$$ = computed(() => this.__filterShow$$())
    get FilterShow() {return this.__filterShow$$()}
    set FilterShow(value: boolean | null) {
        this.__filterShow$$.set(value);
        if (!value) this.settingsOpen_close();
        LogService.envDev.logString('filter', value ? 'show' : 'hide');
    }
    
    private __inputDetection = false;
    get InputDetection() {return this.__inputDetection}
    
    filterActive = true;

    inputDetection_set(value: boolean) {
        this.__inputDetection = value;
    }

    filterShow_toggle() {
        const _filterShow = this.FilterShow;

        this.FilterString = '';
        this.FilterShow = !_filterShow;
    }

}